import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { Button, Flex, Image, Link, Text } from '@cmpsr/components';
import { useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { DashboardNavigationBarProps } from '../types';
import MobileNavigationMenu from './mobile-navigation-menu/mobile-navigation-menu';

export default function DashboardNavigationBarMobile(props: DashboardNavigationBarProps) {
  const [isOpened, setIsOpened] = useState(false);
  const mutateIntercomIsVisible = useSetIntercomIsVisible();

  return (
    <Flex
      as="nav"
      justifyContent="space-between"
      alignItems="center"
      height={{ base: '56px', md: '72px' }}
      px={{ base: 'spacer-4', md: 'spacer-8' }}
      py="spacer-3"
      background="gradient-01"
      w="100%"
      {...props.containerProps}
      ref={props.navBarRef}
    >
      <Link
        width="auto"
        to={ROUTE_DASHBOARD}
        as={ReactRouterLink}
        aria-label="Navigate home"
        alignItems="center"
        justifyContent="flex-start"
        gap={0}
      >
        <Image src="/images/logo-catch.svg" width="112px" height="20px" alt="Catch logo" />
        <Text as="span" display="inline-block" mt="-20px" color="white" fontSize="12px" fontWeight="400">
          beta
        </Text>
      </Link>
      <Button
        variant="accent"
        size="s"
        onClick={() => {
          setIsOpened(true);
          mutateIntercomIsVisible.mutateAsync(false);
        }}
      >
        Menu
      </Button>
      {isOpened && (
        <MobileNavigationMenu
          onClose={() => {
            setIsOpened(false);
            mutateIntercomIsVisible.mutateAsync(true);
          }}
          {...props}
        />
      )}
    </Flex>
  );
}
